import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import ProductDetails from "./products/ProductDetails";

import { productsItems } from "../apis/productsApiSlice";

const Details = () => {
  const products = useSelector(productsItems);
  const { id } = useParams();

  if (products?.length) {
    let filteredProductList = products.filter(
      (product) => parseInt(product.id) === parseInt(id)
    );

    return (
      <section>
        <div className="mb-8">
          <h3 className="text-4xl">Product Details</h3>
        </div>
        {filteredProductList?.length > 0 ? (
          <ProductDetails product={filteredProductList[0]} />
        ) : (
          "No product available...!"
        )}
      </section>
    );
  }
};

export default Details;
